export const translations = {
  'sv': {
    heading: 'Språk',
  },
  'en': {
    heading: 'Language',
  },
  'da': {
    heading: 'Sprog',
  },
  'no': {
    heading: 'Språk',
  },
  'fi': {
    heading: 'Kieli',
  },
  'de': {
    heading: 'Sprache',
  },
  'zh': {
    heading: '语言',
  },
  'fr': {
    heading: 'Langue',
  },
  'es': {
    heading: 'Idioma',
  },
  'nl': {
    heading: 'Spraak',
  },
  'it': {
    heading: 'Idioma',
  },
  'tr': {
    heading: 'Dil',
  },
  'pl': {
    heading: 'Język',
  },
  'pt': {
    heading: 'Linguagem',
  },
  'pt-BR': {
    heading: 'Linguagem',
  },
};
